module.exports = __webpack_public_path__ + "static/media/hero-title.f7f5f36a.png";